module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pkHeader', {
    attrs: {
      "headerTitle": _vm.title,
      "rightContentPropsMain": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nowDate"
  }, [_vm._v("\n        " + _vm._s(_vm.date)), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("(共  " + _vm._s(_vm.data.length) + "  趟航班)")])]), _vm._v(" "), _c('div', {
    ref: "seller",
    staticClass: "seller"
  }, [_c('div', [_vm._l((_vm.data), function(item) {
    return [_c('div', {
      staticClass: "airList",
      on: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    }, [_c('div', {
      staticClass: "weui-cells noth-cells"
    }, [_c('p', {
      staticStyle: {
        "padding": ".5rem 1rem"
      }
    }, [_vm._v(_vm._s(item.airLineCompany) + " " + _vm._s(item.airLineCode))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "1rem 0.2rem 1rem 1rem"
      }
    }, [_c('flexbox', [_c('flexbox-item', {
      attrs: {
        "span": 5
      }
    }, [_c('span', {
      staticClass: "airTime airTimeF"
    }, [_vm._v(_vm._s(item.airLineStartTime))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.airLineStartName) + " ")])]), _vm._v(" "), _c('flexbox-item', {
      attrs: {
        "span": 5
      }
    }, [_c('span', {
      staticClass: "airTime"
    }, [_vm._v(_vm._s(item.airLineEndTime))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.airLineEndName))])]), _vm._v(" "), _c('flexbox-item', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "circle",
      class: {
        bjffab80: item.state == '到达', bj7ecef4: item.state == '起飞', bj8c97cb: item.state == '计划', bj8c97cs: item.state == '延误'
      }
    }, [_vm._v("\n                                    " + _vm._s(item.state) + "\n                                ")])])], 1)], 1)])]
  }), _vm._v(" "), (_vm.data.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1rem",
      "color": "#8e8e8e"
    }
  }, [_vm._v("暂无航班信息")]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ff3456"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickGiveAircraft/serachAircraftList.vue
// module id = 380
// module chunks = 1